import { LOGIN_TYPE } from "@/libs/types/globalTypes";
import { NEXT_PUBLIC_AUTH_SERVICE } from "@/libs/constants/auth";
import { fetchUtil } from "@/libs/fetch";
import routes from "@/helpers/router";

export const generateOtpAPI = async (phoneNumber: string): Promise<any> => {
  const body = {
    loginType: LOGIN_TYPE.PATIENT,
    mobileNumber: phoneNumber,
  };

  try {
    const otpResponse = await fetchUtil({
      url: `${NEXT_PUBLIC_AUTH_SERVICE}/generateOtp`,
      method: "POST",
      body,
      useToken: true,
      credentials: "include",
      isExternalLogin: true,
      ctype: "",
    });

    return otpResponse;
  } catch (err) {
    console.error("Auth service error", err);
  }
};

export const resendOtpAPI = async (mobileNumber: string, loginId: string): Promise<any> => {
  try {
    const resendOtpResponse = await fetchUtil({
      url: `${NEXT_PUBLIC_AUTH_SERVICE}/resendOtp`,
      method: "POST",
      body: { mobileNumber, id: loginId, loginType: "PATIENT" },
      useToken: true,
      credentials: "include",
      isExternalLogin: true,
      ctype: "",
    });

    return resendOtpResponse;
  } catch (err) {
    console.error("Auth service error", err);
  }
};

export const verifyLoginOtpAPI = async (otp: string, loginId: string): Promise<any> => {
  try {
    const authToken = await fetchUtil({
      url: `${NEXT_PUBLIC_AUTH_SERVICE}/verifyLogin`,
      method: "POST",
      body: { otp, id: loginId, loginType: "PATIENT" },
      useToken: true,
      credentials: "include",
      isExternalLogin: true,
      ctype: "",
    });

    return authToken;
  } catch (err) {
    console.error("Auth service error", err);
  }
};
